import request from '@/utils/request'


// 查询设备环境数据记录列表
export function listEnvLog(query) {
  return request({
    url: '/mibo/device-env-log/list',
    method: 'get',
    params: query
  })
}

// 查询设备环境数据记录分页
export function pageEnvLog(query) {
  return request({
    url: '/mibo/device-env-log/page',
    method: 'get',
    params: query
  })
}

// 查询设备环境数据记录详细
export function getEnvLog(data) {
  return request({
    url: '/mibo/device-env-log/detail',
    method: 'get',
    params: data
  })
}

// 新增设备环境数据记录
export function addEnvLog(data) {
  return request({
    url: '/mibo/device-env-log/add',
    method: 'post',
    data: data
  })
}

// 修改设备环境数据记录
export function updateEnvLog(data) {
  return request({
    url: '/mibo/device-env-log/edit',
    method: 'post',
    data: data
  })
}

// 删除设备环境数据记录
export function delEnvLog(data) {
  return request({
    url: '/mibo/device-env-log/delete',
    method: 'post',
    data: data
  })
}
